import { navigate } from 'gatsby';
import get from 'lodash.get';
import React, { forwardRef, useImperativeHandle } from 'react';

import {
  customerCreate,
  getError,
  login,
  setUser,
} from '../../services/shopify';

const Register = (
  { children, setError = () => {}, setLoading = () => {} },
  ref
) => {
  useImperativeHandle(ref, () => ({
    onSubmit({ email, firstName, lastName, password }) {
      setLoading(true);

      customerCreate({
        email,
        firstName,
        lastName,
        password,
      })
        .then((data) => {
          const customerId = get(data, 'customerCreate.customer.id', '');
          const errors = get(data, 'customerCreate.customerUserErrors', []);

          if (customerId) {
            login({
              email,
              password,
            }).then((data) => {
              const token = get(
                data,
                'customerAccessTokenCreate.customerAccessToken',
                {}
              );

              if (token) {
                setUser(token);
                navigate('/account', { replace: true });
              }
            });
          } else {
            setLoading(false);
            setError(getError(errors[0]));
          }
        })
        .catch((err) => {
          const errors = get(
            JSON.parse(JSON.stringify(err)),
            'response.errors',
            []
          );

          setLoading(false);
          setError(getError(errors[0]));
        });
    },
  }));

  return <>{children}</>;
};

export default forwardRef(Register);
